<template>
  <mv-page>
    <mv-default-row>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card flat>
            <v-card-title class="headline">
              Задайте вопрос, и мы ответим на ваш адрес электронной почты
            </v-card-title>
            <v-card-text>
              <v-text-field
              v-if="!emailboxes"
              label="введите ваш адрес электронной почты для ответа"
              v-model="email" type="email"
              ></v-text-field>
              <v-select
              v-else
              :items="emailboxes"
              v-model="email"
              label="Выберите адрес электронной почты для ответа"
              ></v-select>
              <v-textarea
              label="Ваш вопрос"
              v-model="question"
              outline
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" outline
              :disabled="validForm === false"
              @click="send"
              >Отправить</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>

<script>
// eslint-disable-next-line
const emailRe = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
export default {
  name: 'question',
  data: () => ({
    email: null,
    emailboxes: null,
    question: null
  }),
  methods: {
    async fetch () {
      const { emailboxes } = await this.fetchEmailboxes()
      this.emailboxes = emailboxes.map(x => x.address)
    },
    async fetchEmailboxes () {
      return this.$store.dispatch('sioRequest', {
        topic: 'emailboxes-all',
        pl: {}
      })
    },
    async send () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'questions-create',
          pl: { emailbox: this.email, question: this.question }
        })
        this.$store.dispatch('snack', meta.msg)
        this.emailbox = null
        this.question = null
        this.$router.push({ name: 'landing' })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    validEmail () {
      return emailRe.test(String(this.email).toLowerCase())
    },
    validQuestion () {
      if (!this.question) return false
      return this.question.length > 5
    },
    validForm () {
      return this.validEmail && this.validQuestion
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
</style>
